<template>
    <v-app
        id="inspire"
        style="
            max-width: 100vw;
            overflow-x: hidden;
            overflow-y: auto;
        "
    >
        <title-updater></title-updater>
        <v-main>
            <v-container
                fluid
                fill-height
                class="pa-0"
            >
                <v-layout
                    style="
                        max-height: 100vh;
                        overflow-x: hidden;
                        overflow-y: auto;
                    "
                >
<!--                    <v-tooltip-->
<!--                        bottom-->
<!--                    >-->
<!--                        <template v-slot:activator="{ on }">-->
<!--                            <v-btn-->
<!--                                v-on="on"-->
<!--                                absolute-->
<!--                                dark-->
<!--                                fab-->
<!--                                top-->
<!--                                right-->
<!--                                :color="$vuetify.theme.dark ? 'accent' : 'primary'"-->
<!--                                small-->
<!--                                style="-->
<!--                                    top: 2%;-->
<!--                                    right: 2%;-->
<!--                                "-->
<!--                                @click="toggleDarkMode"-->
<!--                            >-->
<!--                                <v-icon>-->
<!--                                    {{ darkMode ? '$mdiWhiteBalanceSunny' : '$mdiWeatherNight' }}-->
<!--                                </v-icon>-->
<!--                            </v-btn>-->
<!--                        </template>-->
<!--                        <span>-->
<!--                            {{ darkMode ? 'Light mode' : 'Dark mode' }}-->
<!--                        </span>-->
<!--                    </v-tooltip>-->

                    <v-flex
                        xs12
                        sm12
                        md8
                        class="auth-background-section"
                    >

                        <div
                            style="
                                position: relative;
                                background-image: url('/static/auth/background.jpg');
                                background-repeat: no-repeat;
                                background-size: cover;
                                background-position: right;
                                height: 100%;
                                width: 100%;
                                left: 150px;
                            "
                        >
                            <img
                                src="/static/auth/front.svg"
                                style="position: absolute; top: 0; left: -150px; right:0; bottom: 0; height: 100%;"
                            >
                        </div>
                    </v-flex>
                    <v-flex
                        xs12
                        sm12
                        md4
                        class="d-flex justify-center align-center"
                    >
                        <v-card
                            flat
                            class="fill-height d-flex flex-column w-full"
                        >
                            <v-card-text
                                class="flex-grow-1 d-flex"
                                :class="isMobile ? 'pa-0 flex-column justify-start align-center' : 'justify-center align-center'"
                            >
                                <div
                                    v-if="isMobile"
                                    style="
                                        width: 100%;
                                        height: 165px;
                                        position: relative;
                                        margin-bottom: 60px;
                                        text-align: center;
                                        display: flex;
                                        flex-direction: column;
                                        justify-content: center;
                                        align-items: center;
                                    "
                                >
                                    <svg
                                        style="position: absolute; top: 0; z-index: 2; height: 170px;"
                                        xmlns="http://www.w3.org/2000/svg"
                                        viewBox="0 0 960 170.26"
                                    >
                                        <path
                                            fill="#3B3B3B"
                                            d="M0,0v141.8C490.3,220.07,784.9,125.05,960,0Z"
                                        />
                                    </svg>
                                    <img
                                        src="/static/auth/logo.svg"
                                        style="
                                            z-index: 3;
                                            width: 250px;
                                            margin-bottom: 5px;
                                        "
                                    >
                                    <img
                                        src="/static/auth/testaro.png"
                                        style="
                                            z-index: 3;
                                            height: 70px;
                                        "
                                    >
                                </div>
                                <slot></slot>
                            </v-card-text>
                            <v-card-actions
                                class="justify-center"
                            >
                                <div
                                    class="caption pa-4 text-center"
                                    :class="$vuetify.theme.dark ? 'accent--text' : 'primary--text'"
                                >
                                    Capital Legacy Solutions (Pty) Ltd is an Authorised Financial Services provider.<br>
                                    The Legacy Protection Plan™ is underwritten by Guardrisk Life Ltd.
                                </div>
                            </v-card-actions>
                        </v-card>
                    </v-flex>
                </v-layout>
            </v-container>
        </v-main>
    </v-app>
</template>
<script>
    import TitleUpdater from './../../functional/Title'

    export default {
        components: {
            TitleUpdater,
        },

        data() {
            return {
                videos: ['1', '2', '3'],
            }
        },
        name: 'Auth-Container',
        computed: {
            video() {
                return this.videos[Math.floor(Math.random() * this.videos.length)];
            },
            darkMode() {
                return this.$vuetify.theme.dark;
            }
        },
        mounted() {
            if (document.getElementById('preloader')) {
                this.$store.dispatch('auth/removePreloader');
            }
        },

        methods: {
            toggleDarkMode() {
                const darkMode = !this.darkMode;
                localStorage.setItem('dark_mode', darkMode);
                this.$vuetify.theme.dark = darkMode;
            }
        }
    }
</script>

